if (!customElements.get('collection-height-filter')) {
  customElements.define(
    'collection-height-filter',
    class CollectionHeightFilter extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[data-height-range]')];
        this.grid = document.getElementById('product-grid');
        this.onClick = this.onClick.bind(this);
        this.buttons.forEach((button) => button.addEventListener('click', this.onClick));

        const requestedRange = new URL(window.location.href).searchParams.get('height') || 'all';
        this.activeRange = this.buttons.some((button) => button.dataset.heightRange === requestedRange)
          ? requestedRange
          : 'all';

        this.observer = new MutationObserver(() => {
          this.grid = document.getElementById('product-grid');
          this.apply();
        });
        this.observer.observe(document.getElementById('ProductGridContainer'), { childList: true, subtree: true });
        this.apply();
      }

      disconnectedCallback() {
        this.buttons?.forEach((button) => button.removeEventListener('click', this.onClick));
        this.observer?.disconnect();
      }

      onClick(event) {
        this.activeRange = event.currentTarget.dataset.heightRange;
        const url = new URL(window.location.href);
        if (this.activeRange === 'all') url.searchParams.delete('height');
        else url.searchParams.set('height', this.activeRange);
        window.history.replaceState({}, '', url);
        this.apply();
      }

      productHeight(item) {
        const title = item.querySelector('.card__heading')?.textContent || '';
        const match = title.match(/(\d{2,3})\s*cm/i);
        return match ? Number(match[1]) : null;
      }

      matches(height, range) {
        if (range === 'all') return true;
        if (height === null) return false;
        if (range === 'under-80') return height < 80;
        if (range === '80-109') return height >= 80 && height <= 109;
        if (range === '110-129') return height >= 110 && height <= 129;
        if (range === '130-plus') return height >= 130;
        return true;
      }

      apply() {
        if (!this.grid) return;
        const items = [...this.grid.querySelectorAll(':scope > li')];
        const counts = { all: items.length, 'under-80': 0, '80-109': 0, '110-129': 0, '130-plus': 0 };

        items.forEach((item) => {
          const height = this.productHeight(item);
          Object.keys(counts).slice(1).forEach((range) => {
            if (this.matches(height, range)) counts[range] += 1;
          });
          item.hidden = !this.matches(height, this.activeRange);
        });

        this.buttons.forEach((button) => {
          const range = button.dataset.heightRange;
          button.setAttribute('aria-pressed', String(range === this.activeRange));
          const count = button.querySelector('[data-height-count]');
          if (count) count.textContent = counts[range];
        });

        const visibleCount = items.filter((item) => !item.hidden).length;
        this.querySelector('[data-height-status]').textContent = `${visibleCount} produkter vises`;
      }
    }
  );
}
